module.exports = __webpack_public_path__ + "static/media/comment.9cf7434c.svg";